import { create } from 'zustand';

export interface SocialState {
  following: string[];
  followerCounts: Record<string, number>;
  setFollowing(list: string[]): void;
  addFollowing(did: string): void;
  removeFollowing(did: string): void;
  setFollowerCount(did: string, n: number): void;
  reset(): void;
}

export const useSocialStore = create<SocialState>((set) => ({
  following: [],
  followerCounts: {},
  setFollowing: (list) => set({ following: [...new Set(list)] }),
  addFollowing: (did) => set((s) => (s.following.includes(did) ? s : { following: [...s.following, did] })),
  removeFollowing: (did) => set((s) => ({ following: s.following.filter((d) => d !== did) })),
  setFollowerCount: (did, n) => set((s) => ({ followerCounts: { ...s.followerCounts, [did]: n } })),
  reset: () => set({ following: [], followerCounts: {} }),
}));

export default useSocialStore;
